import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'

/**
 * Only shows the children if on destop
 */
export const ShowOnDesktop = styled.div`
	display: block;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		display: none;
	}
`
